import { Module, VuexModule, Mutation, Action, getModule } from 'vuex-module-decorators';
import axios from 'axios';
import { toError, assertOk } from '@/services/normalize';
import AuthModule from '@/store/modules/Auth';
// eslint-disable-next-line import/no-cycle
import store from '@/store';

import { BASE_URL, UPDATE_PROFILE, GET_PROFILE, USERS_BALANCE, M_GET, M_PUT, M_POST } from '@/utils/api';

import serviceUtils from '@/services/utils';

const VUE_SESSION_KEY = 'vue-session-key';
const AUTH_KEY = 'ambgames-user-authenticate';

function persistProfileOnly(userPersist: any) {
  const raw = sessionStorage.getItem(VUE_SESSION_KEY);
  let bag: Record<string, any> = {};

  if (raw) {
    try {
      bag = JSON.parse(raw) || {};
    } catch {
      bag = {};
    }
  }

  bag[AUTH_KEY] = JSON.stringify(userPersist);
  sessionStorage.setItem(VUE_SESSION_KEY, JSON.stringify(bag));

  const AuthInstance = getModule(AuthModule, store);
  AuthInstance.setProfile(userPersist.user);
}

@Module({ name: 'profile' })
export default class Profile extends VuexModule {
  totalBalance: any = [];

  @Mutation
  mutateProfile(data: any) {
    this.totalBalance = data;
  }

  @Action({ rawError: true })
  async UpdateProfile(user: Record<string, any>) {
    try {
      const { data } = await axios({
        url: BASE_URL + UPDATE_PROFILE + user.userId,
        data: user,
        method: M_PUT
      });

      assertOk(data, 'Update profile failed');
      return data?.status;
    } catch (err: any) {
      throw toError(err, 'Update profile failed');
    }
  }

  @Action({ commit: 'mutateWinLose' })
  async GetProfile(_id: string) {
    try {
      const { data } = await axios({
        url: BASE_URL + GET_PROFILE + _id.trim(),
        method: M_GET
      });

      assertOk(data, 'Get profile failed');
      return data;
    } catch (err: any) {
      throw toError(err, 'Get profile failed');
    }
  }

  @Action({ rawError: true })
  async FetchProfile() {
    try {
      const getPersist = await serviceUtils.getUserPersistent();
      const userId = getPersist?.user?._id;

      const { data } = await axios({
        url: BASE_URL + GET_PROFILE + userId,
        method: M_GET
      });

      assertOk(data, 'Fetch profile failed');

      const payload = data?.data ?? {};

      const userPersist = { ...getPersist };
      userPersist.user = userPersist.user || {};
      userPersist.user.profile = payload.profile || {};
      userPersist.user.ipWhitelist = payload.ipWhitelist || [];
      userPersist.user.showCurrencySigns = payload.showCurrencySigns || [];

      persistProfileOnly(userPersist);
      return data?.status;
    } catch (err: any) {
      throw toError(err, 'Fetch profile failed');
    }
  }

  @Action({ commit: 'mutateProfile', rawError: true })
  async GetBalance() {
    try {
      const getPersist = await serviceUtils.getUserPersistent();

      const { data } = await axios({
        url: BASE_URL + USERS_BALANCE,
        method: M_POST,
        data: {}
      });

      assertOk(data, 'Fetch balance failed');

      const payload = data?.data ?? {};
      const wallet = payload.wallet ?? 0;

      const userPersist = { ...getPersist };
      userPersist.user = userPersist.user || {};
      userPersist.user.wallet = userPersist.user.wallet || {};
      userPersist.user.wallet.balance = wallet;

      persistProfileOnly(userPersist);

      return { wallet, status: data?.status };
    } catch (err: any) {
      throw toError(err, 'Fetch balance failed');
    }
  }
}
